<template>
  <div>
    <div class="d-flex align-items-center">
      <div
        v-if="incompleteTasks && headerIcon"
        class="
          d-flex
          align-items-center
          justify-content-around
          position-relative
          p-1
          cursor_pointer
          alert-main alert-main__danger
          mr-2
        "
        v-b-tooltip.hover
        :title="$lang.profileLang.incompleteTasksTooltip"
        @click="goToTaskUserPage()"
      >
        <b
          class="mr-2 d-md-block d-none"
          v-text="$lang.profileLang.incompleteTasksText"
        />
        <div class="alert-main__icon">
          <i class="fas fa-tasks" />
        </div>

        <b-badge
          pill
          variant="danger"
          class="alert-main__badge"
          v-text="incompleteTasks"
        />
      </div>
      <div
        v-if="totalIncomplete !== null && headerIcon"
        class="
          d-flex
          align-items-center
          justify-content-around
          position-relative
          p-1
          cursor_pointer
          alert-main
        "
        :class="`alert-main__${!totalIncomplete ? 'success' : 'danger'}`"
        v-b-tooltip.hover
        :title="$lang.profileLang.show_parvandeh_status_tooltip"
        @click="showModal = true"
      >
        <b
          class="mr-2 d-md-block d-none"
          v-if="totalIncomplete"
          v-text="$lang.profileLang.incomplete_parvandeh"
        />
        <div v-show="!totalIncomplete" class="alert-main__icon">
          <i class="fas fa-folder" />
        </div>
        <div v-show="totalIncomplete" class="alert-main__icon">
          <i class="fas fa-folder-open" />
        </div>
        <b-badge
          v-if="totalIncomplete"
          pill
          variant="danger"
          class="alert-main__badge"
          v-text="totalIncomplete"
        />
      </div>
    </div>
    <b-modal
      :title="modalTitle"
      v-model="showModal"
      size="xl"
      hide-footer
      @hidden="hiddenModal"
    >
      <b-row>
        <b-col v-if="!loading" cols="12" md="auto">
          <div
            class="
              d-flex
              align-items-center
              text-primary
              mb-3
              text-left text-c-green
              dir_rtl
            "
          >
            <i
              v-show="calcPercentage(+totalItem, +totalIncompleteItem) === 100"
              class="fas fa-folder fa-lg mr-2"
            />
            <i
              v-show="calcPercentage(+totalItem, +totalIncompleteItem) !== 100"
              class="fas fa-folder-open fa-lg mr-2"
            />
            <b>
              درصد تکمیل شده پرونده شما:
              {{ calcPercentage(+totalItem, +totalIncompleteItem) }}%</b
            >
          </div>
        </b-col>
        <b-col v-if="!loading" cols="12" md="3" class="pt-2">
          <div class="progress">
            <div
              class="progress-bar bg-c-green"
              :style="`width: ${calcPercentage(
                +totalItem,
                +totalIncompleteItem
              )}%`"
            ></div>
          </div>
        </b-col>
        <b-col
          v-if="!loading && !totalIncompleteItem && completeDate"
          cols="12"
          md=""
          class="text-md-right text-left"
        >
          <b v-text="`${$lang.profileLang.parvandeh_complete_date}: `" />
          <span class="text-muted" v-text="completeDate" />
        </b-col>
        <b-col cols="12" md="12" class="mt-md-0 mt-3">
          <b-overlay :show="loading" opacity="1" class="text-center py-2">
            <template #overlay>
              <b-spinner small></b-spinner>
              <strong class="ml-2" v-text="$lang.getInfoLoadingText" />
            </template>

            <b-tabs
              pills
              card
              vertical
              nav-class="p-3 text-left ul_item"
              :nav-wrapper-class="`w-md-25 w-100 ${
                tabsMapped.length <= 1 ? 'd-none' : ''
              }`"
              active-nav-item-class="bg-info"
              @activate-tab="selectTab"
            >
              <b-tab
                v-for="(tab, tabIndex) in tabsMapped"
                :key="tabIndex"
                :active="!tabIndex"
                :title-link-class="tabTitleClass(tabIndex, tab)"
              >
                <template #title>
                  <div class="d-flex align-items-center">
                    <span v-html="tab.icon" />
                    <div>
                      <div
                        v-text="`${$lang.profileLang.level} ${tabIndex + 1}`"
                      />
                      <b v-text="tab.tab_caption" />
                    </div>
                  </div>
                </template>
                <b-card-text>
                  <b-row>
                    <b-col cols="12" md="6">
                      <div class="d-flex align-items-center text-primary mb-3">
                        <i class="fas fa-circle fa-lg mr-2" />
                        <b v-text="tab.tab_caption" />
                      </div>
                    </b-col>
                    <b-col cols="12" md="12">
                      <b-alert
                        show
                        :variant="tab.complete_status ? 'success' : 'danger'"
                        class="font-weight-bold text-left"
                      >
                        <i
                          class="far fa-lg mr-1"
                          :class="
                            tab.complete_status
                              ? 'fa-check-circle'
                              : 'fa-times-circle'
                          "
                        />
                        <span v-text="tab.message" />
                      </b-alert>
                    </b-col>
                  </b-row>
                  <b-row v-if="tab.items" class="m-0">
                    <b-col
                      cols="12"
                      md="12"
                      v-for="(item, index) in tab.items"
                      :key="index"
                      class="mb-2 border rounded p-3"
                    >
                      <div
                        class="
                          text-justify
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div class="d-flex align-items-center">
                          <i
                            class="far mr-1"
                            :class="
                              item.complete_status
                                ? 'fa-check-circle text-success'
                                : 'fa-times-circle text-danger'
                            "
                          />
                          <strong class="text-left" v-text="item.tab_caption" />
                        </div>
                        <b-button
                          v-if="pathOr(null, ['link'], item)"
                          size="sm"
                          v-b-tooltip.hover
                          :title="$lang.profileLang.click_for_complete"
                          variant="outline-primary"
                          v-text="$lang.profileLang.complete_info"
                          @click="goToLink(item)"
                        />
                      </div>
                      <ul class="m-0 text-danger text-justify fs_12">
                        <li
                          v-for="(message, messageIndex) in item.message"
                          :key="messageIndex"
                          v-text="message"
                        />
                      </ul>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-overlay>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import { checkActiveParvandeh, calcPercentage } from "@/shared/utils";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    headerIcon: {
      type: Boolean,
      default: true,
    },
    openModal: {
      type: Boolean,
      default: false,
    },
    parentParvandehCode: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: "my",
    },
  },
  data() {
    return {
      loading: false,
      activeParvandehData: {},
      activeTabIndex: 0,
      tabs: [],
      showModal: false,
      data: {},
    };
  },
  computed: {
    ...mapGetters(["totalIncomplete", "incompleteTasks"]),
    parvandehCode() {
      return pathOr(null, ["code"], this.activeParvandehData);
    },
    tabsMapped() {
      return this.tabs.map((tab, index) => {
        const completeStatus = pathOr(false, ["complete_status"], tab);
        const items = pathOr([], ["items"], tab);
        tab.items = [...items.filter((item) => !item.complete_status)];
        let icon = "";
        let message = `اطلاعات به طور کامل ثبت شده است`;
        if (!completeStatus) {
          const unCompleteCount = pathOr(0, ["tab_incomplete_item"], tab);
          message = `اطلاعات ${unCompleteCount} بخش زیر تکمیل نشده است`;
        }
        if (index === this.activeTabIndex) {
          icon = "<i class='fas fa-circle fa-2x mr-2' />";
        } else {
          icon = completeStatus
            ? "<i class='fas fa-check-circle fa-2x mr-2' />"
            : "<i class='far fa-circle fa-2x mr-2' />";
        }
        return {
          ...tab,
          icon,
          message,
        };
      });
    },
    modalTitle() {
      const termCaption = pathOr("", ["term_caption"], this.data);
      const parvandehNumber = pathOr("", ["parvandeh_number"], this.data);
      return this.loading
        ? ""
        : `${this.$lang.profileLang.parvandeh_status} ${termCaption} (${parvandehNumber})`;
    },
    totalItem() {
      return pathOr(0, ["total_item"], this.data);
    },
    totalIncompleteItem() {
      return pathOr(0, ["total_incomplete_item"], this.data);
    },
    completeDate() {
      return pathOr(null, ["updated_at", "jalali"], this.data);
    },
  },
  watch: {
    showModal(value) {
      value && this.getParvandehDetail();
    },
    openModal(value) {
      if (value) this.showModal = true;
    },
  },
  created() {
    /* guidance: get data just call when component use in header */
    if (this.headerIcon) {
      this.getStatus();
    }
  },
  methods: {
    ...mapActions(["getParvandehStatus"]),
    pathOr,
    checkActiveParvandeh,
    calcPercentage,
    async getStatus() {
      this.reset();
      try {
        this.loading = true;
        await this.getParvandehStatus(this.parentParvandehCode);
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async getParvandehDetail() {
      this.reset();
      this.activeParvandehData = { ...checkActiveParvandeh(false) };
      if (!this.parvandehCode && !this.parentParvandehCode) {
        return;
      }
      try {
        this.loading = true;
        const parvandehCode = this.parentParvandehCode || this.parvandehCode;
        const url =
          this.$config.api_url +
          this.$config.profile.parvandeh_status_detail.replace(
            "{0}",
            parvandehCode
          );
        const response = await this.$httpService.get(url);
        this.data = { ...pathOr({}, ["data", "data"], response) };
        this.tabs = [...pathOr({}, ["data", "data", "tabs"], response)];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    selectTab(value) {
      this.activeTabIndex = value;
    },
    tabTitleClass(index, item) {
      if (index === this.activeTabIndex) return;
      return pathOr(false, ["complete_status"], item)
        ? ["bg-success", "text-white"]
        : ["bg-secondary", "text-dark"];
    },
    goToLink(item) {
      const personCode = pathOr(null, ["link", "person_code"], item);
      const tabName = pathOr(null, ["link", "tab_name"], item);
      if (!personCode || !tabName)
        return this.$notify.warning("لینک صفحه موردنظر در دسترس نیست");
      const routeName = this.target === "my" ? "profile" : "editPerson";

      const routeData = {
        name: routeName,
        params: { code: personCode, target: tabName },
      };

      /* guidance: if show of header (show my profile) not open new tab else show person profile in new tab */
      if (this.headerIcon) {
        this.showModal = false;
        this.$router.push(routeData);
      } else {
        const routerData = this.$router.resolve(routeData);
        window.open(routerData.href, "_blank");
      }
    },
    reset() {
      this.$emit("destroyed");
      this.activeParvandehData = {};
      this.activeTabIndex = 0;
      this.tabs = [];
      this.data = {};
    },
    async hiddenModal() {
      this.headerIcon && (await this.getStatus());
      this.reset();
    },
    goToTaskUserPage() {
      this.$router.push({ name: "task_user" }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ul_item {
  .nav-item {
    position: relative;
    z-index: 1;
    margin-top: 25px;
    border: 1px solid #343a40;
    border-radius: 0.25rem;
    &::after {
      content: "";
      width: 1px;
      height: 25px;
      position: absolute;
      background-color: #343a40;
      left: 0;
      right: 29px;
      bottom: -26px;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
}
.alert-main {
  &__danger {
    color: rgba(255, 82, 82, 1);
    .alert-main__icon {
      border: 1px solid rgba(255, 82, 82, 1);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
      animation: pulse 2s infinite;
    }
    .alert-main__badge {
      background-color: rgba(255, 82, 82, 1);
    }
  }
  &__success {
    color: rgba(51, 217, 178, 1);
    .alert-main__icon {
      border: 1px solid rgba(51, 217, 178, 1);
      box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
    }
    .alert-main__badge {
      display: none;
    }
  }
}
.alert-main__icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.alert-main__badge {
  position: absolute !important;
  top: -2px !important;
  left: 0px !important;
  border-radius: 50% !important;
  width: 15px !important;
  height: 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
}
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}

/* progress */
.flex {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

.padding {
  padding: 3rem;
}

h6 {
  font-size: 16px !important;
}

.text-c-green {
  color: #2ed8b6 !important;
}

.m-l-10 {
  margin-left: 10px;
}

.progress {
  height: 6px;
  overflow: visible;
  margin-bottom: 10px;
}

.progress .progress-bar {
  position: relative;
}

.progress .progress-bar {
  height: 100%;
  color: inherit;
}

.bg-c-red {
  background: #ff5370;
}

.progress .progress-bar.bg-c-red:after {
  border: 3px solid #ff5370;
}

.progress .progress-bar:after {
  content: "";
  background: #fff;
  position: absolute;
  right: -6px;
  top: -4px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
}

.bg-c-blue {
  background: #4099ff;
}

.progress .progress-bar.bg-c-blue:after {
  border: 3px solid #4099ff;
}

.progress .progress-bar.bg-c-green:after {
  border: 3px solid #2ed8b6;
}

.bg-c-green {
  background: #2ed8b6;
}

.bg-c-yellow {
  background: #ffb64d;
}

.progress .progress-bar.bg-c-yellow:after {
  border: 3px solid #ffb64d;
}

.m-b-30 {
  margin-bottom: 30px;
}
</style>
